import React, { useState } from 'react';
import './ServiceRequest.css'; 

const ServiceRequestForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    serviceType: '',
    message: '',
    purchaseDate: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  
    // Update the URL to the live backend URL
    fetch('https://sskvbackend.onrender.com/api/service-request', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          alert('Service request submitted successfully!');
        } else {
          alert('Failed to submit the service request. Please try again.');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('There was an error submitting your request.');
      });
  };
  

  return (
    <div className="service-request-form">
      <h2>Service Request Form</h2>
      <form onSubmit={handleSubmit}>

 
        <div className="form-row">
          <label>
            Name:
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>
        </div>

  
        <div className="form-row">
          <label>
            Phone:
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </label>
          <label>
            Service Type:
            <select
              name="serviceType"
              value={formData.serviceType}
              onChange={handleChange}
              required
            >
              <option value="">Select a service</option>
              <option value="warranty">1 Year Warranty</option>
              <option value="maintenance">Maintenance</option>
              <option value="installation">Installation</option>
              <option value="support">Customer Support</option>
            </select>
          </label>
        </div>


        <div className="form-row">
          <label>
            Purchase Date:
            <input
              type="date"
              name="purchaseDate"
              value={formData.purchaseDate}
              onChange={handleChange}
              required
            />
          </label>
        </div>

        <div className="form-row full-width">
          <label>
            Message:
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
            />
          </label>
        </div>

        <button type="submit">Submit Request</button>
      </form>
    </div>
  );
};

export default ServiceRequestForm;
